import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	loadMore: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	loadMore: {
		id: 'issue-history.history-items.load-more',
		defaultMessage: 'Load more',
		description: 'Button label - when clicked, will load more history items for history feed',
	},
});
export default messages;
